import React from 'react';
import { Image as ImageIcon, Loader2 } from 'lucide-react';
import { useVendorPortfolioImages } from '../../../services/vendorService';

const PortfolioTab = ({ vendorProfile }) => {
  const vendorId = vendorProfile?.id;
  const { data: portfolioData, isLoading } = useVendorPortfolioImages(vendorId, {}, {
    enabled: !!vendorId
  });
  
  const portfolioImages = portfolioData?.data || [];

  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-12">
        <Loader2 className="w-8 h-8 animate-spin text-primary-600" />
      </div>
    );
  }

  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 sm:mb-6 gap-2">
        <h3 className="text-base sm:text-lg font-medium text-gray-900">Portfolio Images</h3>
        <span className="text-sm text-gray-500">{portfolioImages.length} {portfolioImages.length === 1 ? 'image' : 'images'}</span>
      </div>
      
      {portfolioImages.length > 0 ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4">
          {portfolioImages.map((image) => (
            <div key={image.id} className="group relative aspect-square bg-gray-100 rounded-lg overflow-hidden border border-gray-200 hover:shadow-md transition-shadow">
              <img
                src={image.image_url || '/placeholder-image.jpg'}
                alt={image.file_name || 'Portfolio image'}
                className="w-full h-full object-cover"
              />
              {image.description && (
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-50 transition-all duration-200 flex items-center justify-center p-2">
                  <p className="text-white text-xs opacity-0 group-hover:opacity-100 transition-opacity text-center line-clamp-3">
                    {image.description}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8 sm:py-12">
          <ImageIcon className="w-12 h-12 sm:w-16 sm:h-16 text-gray-400 mx-auto mb-4" />
          <h3 className="text-base sm:text-lg font-medium text-gray-900 mb-2">No Portfolio Images</h3>
          <p className="text-sm text-gray-600">This vendor hasn't uploaded any portfolio images yet.</p>
        </div>
      )}
    </div>
  );
};

export default PortfolioTab;

